import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ISeguimentTecnic, IProjectSeguimentTecnicResponse } from './manage-seguiment-tecnic.interfaces';

@Injectable()
export class ManageSeguimentTecnicService {
  private _API_BASE_URL: string = environment['API_URL'];

  public getByProject(projectCode: string): Observable<IProjectSeguimentTecnicResponse> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'seguimentTecnicProj/project/' + projectCode)
      .pipe(map(response => response || []));
  }

  public get(): Observable<IProjectSeguimentTecnicResponse> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'seguimentTecnicProj')
      .pipe(map(response => response || []));
  }

  public getById(seguimentId: string): Observable<ISeguimentTecnic> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'seguimentTecnicProj/' + seguimentId)
      .pipe(map(response => response || {}));
  }

  public create(payload: ISeguimentTecnic): Observable<ISeguimentTecnic> {
    return this.authHttp.post<any>(this._API_BASE_URL + 'seguimentTecnicProj/', payload)
      .pipe(map(response => response || {}));
  }

  public update(seguimentId: number, payload: ISeguimentTecnic): Observable<ISeguimentTecnic> {
    return this.authHttp.put<any>(this._API_BASE_URL + 'seguimentTecnicProj/' + seguimentId, payload)
      .pipe(map(response => response || []));
  }

  public destroy(seguimentId: number): Observable<ISeguimentTecnic> {
    return this.authHttp.delete<any>(this._API_BASE_URL + 'seguimentTecnicProj/' + seguimentId)
      .pipe(map(response => response || []));
  }

  constructor(private authHttp: HttpClient) { }

}
